var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('base-header',{staticClass:"rsgradient pb-3 pb-1 pt-3 pt-md-5",attrs:{"type":""}}),_c('b-card',{staticStyle:{"margin":"20px"}},[_c('div',{staticStyle:{"text-align":"center"}},[_c('iframe',{attrs:{"height":"500","width":"100%","src":_vm.$store.getters.UrlTawkTo}})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }